<div class="payment-static-success-wrapper">
  <div class="payment-static-status-icon">
    <img [src]="sanitizing.bypassSecurityTrustUrl(helperService.paymentStatusesIcons['SUCCESS'])" alt="ok" />
  </div>
  <div class="payment-static-status-title">
    {{
      paymentService.paymentInProgress$$.value?.claim_processed
        ? ('claim_refund.success_title' | translate)
        : ('payment.success_title' | translate)
    }}
  </div>
  <div class="payment-static-status-description {{ !isRedirectShown ? 'mb-30' : null }}">
    {{
      paymentService.paymentInProgress$$.value?.claim_processed
        ? ('payment.claim_processed' | translate)
        : ('payment.status_description' | translate)
    }}
  </div>
  <div
    *ngIf="isRedirectShown"
    class="payment-static-status-redirect-info mb-30"
    [innerHTML]="'payment.redirect_details' | translate: { callback_endpoint: callbackEndpoint }"
  ></div>
</div>
